import { FormEvent, FunctionComponent, useState } from 'react'
import { Alert, Box, Button, Snackbar, Typography } from '@mui/material'
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'
import { Appearance, loadStripe } from '@stripe/stripe-js'
import theme from 'src/theme'

let stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? '')

let appearance: Appearance = {
  theme: 'night',
  variables: {
    colorPrimary: theme.palette.primary.main,
    colorBackground: theme.palette.background.paper,
  },
}

let CheckoutForm: FunctionComponent = () => {
  let stripe = useStripe()
  let elements = useElements()

  let [errorMessage, setErrorMessage] = useState<string>('')
  let [isLoading, setIsLoading] = useState<boolean>(false)

  let handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!stripe || !elements) {
      return
    }

    setIsLoading(true)

    let { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${import.meta.env.VITE_FRONTEND_URL}/thank-you`,
      },
    })

    if (error) {
      setErrorMessage(
        error.type === 'card_error' || error.type === 'validation_error'
          ? error.message || ''
          : 'Payment Failed',
      )
    }

    setIsLoading(false)
  }

  return (
    <>
      <Box sx={{ pb: 3 }}>
        <form id="payment-form" onSubmit={handleSubmit}>
          {/* <LinkAuthenticationElement
            id="link-authentication-element"
            onChange={(event) => {
              setEmail(event.value.email)
            }}
            options={{ defaultValues: { email } }}
          /> */}
          <Typography sx={{ my: 1, textAlign: 'center' }} variant="h6">
            Payment
          </Typography>
          <PaymentElement
            id="payment-element"
            options={{
              wallets: { applePay: 'auto', googlePay: 'never' },
              paymentMethodOrder: ['bank', 'card', 'link', 'apple_pay'],
              // layout: 'accordion',
              layout: 'tabs',
              business: { name: 'FOAMfrat LLC' },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={isLoading || !stripe || !elements}
              type="submit"
              className="w-1/2"
            >
              Subscribe
            </Button>
          </Box>
        </form>
        <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
          <Alert
            variant="filled"
            onClose={() => setErrorMessage('')}
            severity="error"
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )
}

export let Elems = ({ clientSecret }: { clientSecret: string }) => (
  <Elements
    stripe={stripePromise}
    options={{ clientSecret, appearance, loader: 'auto' }}
  >
    <CheckoutForm />
  </Elements>
)
